import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { useState, useEffect } from "react";
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => !["showCloseButton", "size"].includes(prop)
})(({
  theme,
  showCloseButton,
  size
}) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.colors.surface.primary,
    borderRadius: theme.sizes.radius.sm,
    fontSize: theme.fonts.size.sm,
    fontFamily: theme.fonts.family.body,
    color: theme.colors.text.primary,
    height: size === "small" ? void 0 : theme.sizes.spacing["10"],
    "& fieldset": {
      borderColor: theme.colors.border.tertiary,
      borderWidth: "1px"
    },
    "&:hover fieldset": {
      borderColor: theme.colors.border.focus
    },
    "&:hover": {
      backgroundColor: theme.colors.surface.secondary
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.colors.border.focus,
      borderWidth: "1px"
    }
  },
  "& .MuiInputBase-input": {
    padding: `${theme.sizes.spacing["03"]} ${theme.sizes.spacing["04"]}`,
    backgroundColor: "transparent",
    "&::placeholder": {
      color: theme.colors.text.tertiary,
      opacity: 1
    }
  },
  "& .MuiInputAdornment-root": {
    color: theme.colors.text.secondary,
    marginLeft: theme.sizes.spacing["03"]
  },
  "& .MuiInputAdornment-positionEnd": {
    visibility: showCloseButton ? "visible" : "hidden"
  }
}));
const ClearButton = styled(IconButton)(({
  theme
}) => ({
  padding: 0,
  color: theme.colors.icon.secondary,
  "&:hover": {
    backgroundColor: "transparent"
  }
}));
const SearchBar = (t0) => {
  const $ = c(26);
  const {
    value,
    onChange,
    placeholder: t1,
    className,
    size: t2,
    fullWidth: t3
  } = t0;
  const placeholder = t1 === void 0 ? "Search..." : t1;
  const size = t2 === void 0 ? "small" : t2;
  const fullWidth = t3 === void 0 ? false : t3;
  const [internalValue, setInternalValue] = useState(value);
  let t4;
  let t5;
  if ($[0] !== value) {
    t4 = () => {
      setInternalValue(value);
    };
    t5 = [value];
    $[0] = value;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[3] !== internalValue || $[4] !== onChange || $[5] !== value) {
    t6 = () => {
      const timeoutId = setTimeout(() => {
        if (internalValue !== value) {
          onChange(internalValue);
        }
      }, 250);
      return () => clearTimeout(timeoutId);
    };
    t7 = [internalValue, onChange, value];
    $[3] = internalValue;
    $[4] = onChange;
    $[5] = value;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t8 = (event) => {
      setInternalValue(event.target.value);
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const handleInputChange = t8;
  let t9;
  if ($[9] !== onChange) {
    t9 = () => {
      setInternalValue("");
      onChange("");
    };
    $[9] = onChange;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const handleClear = t9;
  let t10;
  if ($[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t10 = /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(FontAwesomeIcon, { icon: faMagnifyingGlass, size: "sm" }) });
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const startAdornment = t10;
  let t11;
  if ($[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t11 = /* @__PURE__ */ jsx(FontAwesomeIcon, { icon: faCircleXmark, size: "sm" });
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== handleClear || $[14] !== size) {
    t12 = /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(ClearButton, { "aria-label": "Clear search", onClick: handleClear, size, children: t11 }) });
    $[13] = handleClear;
    $[14] = size;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const endAdornment = t12;
  let t13;
  if ($[16] !== endAdornment) {
    t13 = {
      input: {
        startAdornment,
        endAdornment
      }
    };
    $[16] = endAdornment;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = internalValue.length > 0;
  let t15;
  if ($[18] !== className || $[19] !== fullWidth || $[20] !== internalValue || $[21] !== placeholder || $[22] !== size || $[23] !== t13 || $[24] !== t14) {
    t15 = /* @__PURE__ */ jsx(StyledTextField, { className, value: internalValue, onChange: handleInputChange, placeholder, variant: "outlined", size, slotProps: t13, showCloseButton: t14, fullWidth });
    $[18] = className;
    $[19] = fullWidth;
    $[20] = internalValue;
    $[21] = placeholder;
    $[22] = size;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
};
export {
  SearchBar as default
};
